import type {
  ColumnGroupPreferenceState,
  ColumnPreferenceState,
  IBlotterPreferenceState,
} from 'components/shared/Blotter/Grid/blotter.model';
import { isEqual } from 'lodash-es';

import type { Sort } from './blotter.model';

export function onColumnStateChanged<
  T extends { blotterPreferenceState: IBlotterPreferenceState },
  A extends { columnState: readonly ColumnPreferenceState[]; columnGroupState?: readonly ColumnGroupPreferenceState[] },
>(state: T, action: A): T {
  return {
    ...state,
    blotterPreferenceState: {
      ...state.blotterPreferenceState,
      columnState: isEqual(state.blotterPreferenceState.columnState, action.columnState)
        ? state.blotterPreferenceState.columnState
        : action.columnState,
      columnGroupState: isEqual(state.blotterPreferenceState.columnGroupState, action.columnGroupState)
        ? state.blotterPreferenceState.columnGroupState
        : action.columnGroupState,
    },
  };
}

export function onPageChanged<T extends { page: number }, A extends { page: number }>(state: T, { page }: A): T {
  return { ...state, page };
}

export function onDisplayedItemsCntChanged<T extends { displayedItemsCnt: number }, A extends { cnt: number }>(
  state: T,
  { cnt }: A,
): T {
  return { ...state, displayedItemsCnt: cnt };
}
export function onItemsPerPageChanged<
  T extends { blotterPreferenceState: IBlotterPreferenceState; page: number },
  A extends { itemsPerPage: number },
>(state: T, { itemsPerPage }: A): T {
  return {
    ...state,
    blotterPreferenceState: { ...state.blotterPreferenceState, pageSizeState: itemsPerPage },
    page: 1,
  };
}

export function onColumnSortChanged<
  T extends { sort: readonly Sort[] },
  A extends { sort: string | null; sortDir: 'asc' | 'desc' | null },
>(state: T, { sort, sortDir }: A): T {
  if (sort === null) {
    return { ...state, sort: [] };
  }
  const stateSort = [...state.sort];
  const sortIdx = state.sort.findIndex(s => s.column === sort);
  if (sortDir === null || sort === null) {
    if (sortIdx < 0) {
      return state;
    } else {
      stateSort.splice(sortIdx, 1);
    }
  } else {
    if (sortIdx < 0) {
      stateSort.push({ column: sort, direction: sortDir });
    } else {
      stateSort[sortIdx] = { column: sort, direction: sortDir };
    }
  }
  return { ...state, sort: stateSort };
}
